import axios from 'axios'

const service = axios.create({
  baseURL: process.env.MIX_BASE_API,
  timeout: 10000,
});

export default service;
